import * as React from "react"
import * as _ from "lodash"
import { connect } from "react-redux"
import { NavItem } from "react-bootstrap"
import { LinkContainer } from "react-router-bootstrap"
import { IAppointmentScheduleResponse, IPatientDetail } from "@curefit/care-common";
import * as RoutesConfig from "../../routes"
import { RouteUtils } from "../../routes"
import PatientConsultationSummary from "../../components/patient/PatientConsultationSummary";
import ConsultationDetailsHeader from "../../components/common/ConsultationDetailsHeader";
import { default as AppUtils, LOADING_STATE } from "../../utils/AppUtils"
import {
    AppConstants,
    ConsultationStatusConstant,
    CONSULTATION_CHANNELS,
    FeatureConfigValues,
    DoctorType,
    APP_TENANTS,
    SUPPORTED_DOCTOR_TYPES_FOR_PACK_DETAILS
} from "../../utils/AppConstants"
import PatientMedicationHistoryContainer from "../../components/patient/PatientMedicationHistoryContainer";
import { IAppState } from "../../models/IAppState";
import IDoctorProfile from "../../models/IDoctorProfile";
import ConsultationUtils from "../../utils/ConsultationUtils";
import { OngoingConsultationActions } from "../../actions/OngoingConsultationActions";
import { IAccessToken } from "../../models/ICommunication";
import { PrescriptionAction } from "../../actions/PrescriptionActions";
import AppLoader from "../../components/utils/AppLoader";
import ErrorContainer from "../ErrorContainer";
import IMedicineType from "../../models/staticData/IMedicineType";
import { AllStaticDataActions } from "../../actions/AllStaticDataActions";
import ConfirmModalContainer from "../ConfirmModalContainer";
import ISystemicExaminationStaticData from "../../models/staticData/ISystemicExaminationStaticData";
import { TwilioActions } from "../../actions/TwilioActions";
import CurrentDateTimeContainer from "../../components/common/CurrentDateTimeContainer";
import { IOngoingConsultation } from "../../models/IOngoingConsultation";
import { ApiManager } from "../../api/ApiManager";
import { PatientPersonalProfile } from "@curefit/ups-common";
import { EditPrescriptionActions } from "../../actions/EditPrescriptionActions"
import { OverrideActions } from "../../actions/OverrideActions"
import { EventNames } from "../../utils/EventTrackerConstants";
import CTA, { CTATheme } from "../../components/common/CallToAction";
import TherapyConsultationDetailView from "./TherapyConsultationDetailsView";
import { WhatsAppChatActions } from "../../actions/WhatsAppChatActions"
import { WhatsAppPatientInfo } from "../../components/WhatsAppChatComponent"

export interface PatientConsultationDetailContainerProps {
    params?: any;
    routeParams?: any;
    staticSystemicExams: ISystemicExaminationStaticData;
    medicineTypes: IMedicineType[],
    chatAccessToken: IAccessToken;
    doctorProfile: IDoctorProfile;
    fetchAllStaticData: () => void;
    fetchChatContext: (appointmentId: number, commUserId: number) => void;
    sendPrescription: (bookingId: number, appointmentId: number) => Promise<any>;
    sendPlan: (appointmentId: number, curefitUserId: string, bookingId: number) => Promise<any>;
    downloadPrescription: (id: number, type: string) => void;
    printPrescription: (id: number, type: string) => void;
    updateCurrentChannelWithPatient: (channelSid: string, patient: IPatientDetail, identity: string) => void;
    saveConsultationData: (consultationData: IOngoingConsultation) => void;
    overridePatientNumberForAudioCall(phoneNumber: number): any;
    isTreatmentPlanEnabled: boolean;
    updateWhatsAppChatContext: (patientInfo: WhatsAppPatientInfo) => void,
    closeWhatsAppChatContext: () => void,
    appTenant?:string,
}


export interface PatientConsultationDetailContainerState {
    confirmationText?: string,
    errorMessage: string;
    consultation: IAppointmentScheduleResponse;
    consultationDetailsLoaded: LOADING_STATE;
    caseSummary: string;
    consultationData: IOngoingConsultation;
    patientPersonalProfile: PatientPersonalProfile
}

class PatientConsultationDetailContainer extends React.PureComponent<PatientConsultationDetailContainerProps, PatientConsultationDetailContainerState> {
    private loadStartTime: number = AppUtils.getCurrentTime()
    constructor(props: PatientConsultationDetailContainerProps) {
        super(props);
        this.state = {
            confirmationText: null,
            errorMessage: null,
            consultation: null,
            consultationDetailsLoaded: LOADING_STATE.NOT_INITIALIZED,
            caseSummary: null,
            consultationData: null,
            patientPersonalProfile: null
        }
    };

    getConsultationId = (props: PatientConsultationDetailContainerProps) => {
        return parseInt(props.params[RoutesConfig.CONSULTATION_ID_PARAM]);
    }

    setStateFromProps = async (props: PatientConsultationDetailContainerProps) => {

        const isMobile = AppUtils.getIsMobile();
        let appointment
        try {
            appointment = await ApiManager.getAlbusApis().fetchAppointmentChatContextAndOrderAssetsById(this.getConsultationId(props), ConsultationUtils.isPackInfoRequired(props.doctorProfile.type));
            if (appointment && appointment.channel && appointment.channel === CONSULTATION_CHANNELS.AUDIO && appointment.appointmentActionsWithContext && appointment.appointmentActionsWithContext.audioActionWithContext
                && appointment.appointmentActionsWithContext.audioActionWithContext.context
                && appointment.appointmentActionsWithContext.audioActionWithContext.context.twilioCommunicationMode
                && appointment.appointmentActionsWithContext.audioActionWithContext.context.twilioCommunicationMode.modeName) {
                this.props.overridePatientNumberForAudioCall(parseInt(appointment.appointmentActionsWithContext.audioActionWithContext.context.twilioCommunicationMode.modeName));
            }
        } catch (error) {
            throw (error);
        }

        let channelSid = _.get(appointment, "appointmentActionsWithContext.chatActionWithContext.context.twilioCommunicationMode.modeSid", null);
        const isAppointmentNotEmpty = !_.isEmpty(appointment);
        const isAppointmentPatientNotEmpty = isAppointmentNotEmpty && !_.isEmpty(appointment.patient);
        // added check for mobile because we dont want chat to open up automatically on mobile.
        if(!isMobile && this.props.appTenant === APP_TENANTS.SUGARFIT && this.props.doctorProfile.type === SUPPORTED_DOCTOR_TYPES_FOR_PACK_DETAILS.LIFESTYLE_COACH){
            const whatsAppPatientInfo: WhatsAppPatientInfo = {
                doctorId: this.props.doctorProfile.id,
                name: appointment.patient.name,
                mobileNo: appointment.patient.userPhoneNumber || appointment.patient.phoneNumber
            }
            this.setWhatsAppContext(whatsAppPatientInfo);
        }
        else if (!isMobile && isAppointmentNotEmpty && !_.isEmpty(channelSid) && AppUtils.shouldOpenChatWindowForConsultation(appointment, props.doctorProfile.id)) {
            const memeberIdentity = _.get(appointment, "appointmentActionsWithContext.chatActionWithContext.context.twilioCommunicationMode.doctorTwilioUser.identity", "");
            props.updateCurrentChannelWithPatient(channelSid, appointment.patient, memeberIdentity);
        }

        let consultationData = null
        try {
            if (isAppointmentNotEmpty && AppUtils.isDefined(appointment.id) && !_.isEmpty(appointment.consultationProduct) && isAppointmentPatientNotEmpty) {
                consultationData = await ApiManager.getOrionApis().fetchPastConsultationDataForPatient(appointment.id.toString(), appointment.consultationProduct.subServiceType, appointment.patient.id.toString())
            }
        } catch (e) {
            throw (e)
        }

        let patientPersonalProfile
        try {
            if (isAppointmentPatientNotEmpty) {
                patientPersonalProfile = await ApiManager.getPolarisApis().getPatientPersonalProfile(Number(appointment.patient.curefitUserId), appointment.patient.id, AppUtils.isPatientRelationSelf(appointment.patient))
            }
        } catch (e) {
            console.log("Unable to fetch personal profile", e)
        }

        const [path, urlParams] = window.location.search.split("?")
        const trackingParams = urlParams
            ? urlParams.split("&").reduce((acc: any, curr: string) => {
                const [key, val] = curr.split("=")
                acc[key.replace("utm_", "")] = val
                return acc
            }, {})
            : {}
        AppUtils.updatePageLoadEvent(EventNames.ConsultationDetails, "", this.loadStartTime, trackingParams)
        this.setState({
            consultation: appointment,
            caseSummary: consultationData.caseSummary,
            consultationData: consultationData.consultationData,
            patientPersonalProfile,
            consultationDetailsLoaded: LOADING_STATE.LOADED
        });
    }

    setWhatsAppContext = (patientInfo: WhatsAppPatientInfo) => {
        this.props.closeWhatsAppChatContext();
        setTimeout(() => this.props.updateWhatsAppChatContext(patientInfo), 300);
    }

    async componentDidMount() {
        await this.setStateFromProps(this.props)
        if (!this.props.chatAccessToken) this.props.fetchChatContext(this.getConsultationId(this.props), this.props.doctorProfile.id);
        if (_.isNull(this.props.medicineTypes)) this.props.fetchAllStaticData();
    }

    componentWillReceiveProps(nextProps: PatientConsultationDetailContainerProps, nextState: PatientConsultationDetailContainerState) {
        if (this.props.routeParams.patientId !== nextProps.routeParams.patientId || this.props.routeParams.consultationId !== nextProps.routeParams.consultationId) {
            this.loadStartTime = AppUtils.getCurrentTime()
            this.setState({
                consultationDetailsLoaded: LOADING_STATE.LOADING
            }, () => {
                this.setStateFromProps(nextProps)
            })
        }
    }

    printPrescription = () => {
        if (!_.isEmpty(this.state.consultation) && !_.isEmpty(this.state.consultation.orderAssets) && !_.isEmpty(this.state.consultation.orderAssets.orderAssetList)) {
            const printAsset = this.state.consultation.orderAssets.orderAssetList.find((asset: any) => asset.assetType.indexOf(AppConstants.pdfAttachmentAction.PRINT) > -1);
            if (printAsset) {
                this.props.printPrescription(this.state.consultation.id, printAsset.assetType);
            }
        }
    }

    previewPrescription = () => {
        if (!_.isEmpty(this.state.consultation) && !_.isEmpty(this.state.consultation.orderAssets) && !_.isEmpty(this.state.consultation.orderAssets.orderAssetList)) {
            const printAsset = this.state.consultation.orderAssets.orderAssetList.find((asset: any) => asset.assetType.indexOf(AppConstants.pdfAttachmentAction.EMAIL) > -1);
            if (printAsset) {
                this.props.downloadPrescription(this.state.consultation.id, printAsset.assetType);
            }
        }
    }

    emailPrescription = () => {
        if (AppUtils.isLifeStyleConsultation(this.state.consultation) ||
            AppUtils.isMindConsultation(this.state.consultation) ||
            AppUtils.isPhysiotherapistConsultation(this.state.consultation)) {
            this.props.sendPlan(this.getConsultationId(this.props), this.state.consultation.patient.curefitUserId, this.state.consultation.bookingId).then((data) => {
                this.setState({ errorMessage: "Email successfully sent" })
            }).catch((err) => {
                this.setState({ errorMessage: "Could not send email" })
            });
        } else {
            this.props.sendPrescription(this.state.consultation.bookingId, this.getConsultationId(this.props)).then((data) => {
                this.setState({ errorMessage: "Email successfully sent" })
            }).catch((err) => {
                this.setState({ errorMessage: "Could not send email" })
            });
        }
    }

    clearErrorMessage = () => {
        this.setState({
            errorMessage: null
        })
    }

    clearConfirmMessage = () => {
        this.setState({
            confirmationText: null
        })
    }

    showConfirmBox = (evt: any, consultationURL: string) => {
        let consultationMode = AppConstants.ConsultationModes[this.state.consultation.consultationProduct.consultationMode].id;
        if (consultationMode === AppConstants.ConsultationModes.INCENTRE.id && this.state.consultation.status !== ConsultationStatusConstant.VITALS_COLLECTED) {
            this.setState({
                confirmationText: "Vitals not collected yet. Are you sure you want to start the consultation?"
            })
        } else {
            RouteUtils.navigateToHrefUrl(evt, consultationURL);
        }
    }

    handleOkCallBack = (e: any, startConsultationUrl: string) => {
        RouteUtils.navigateToHrefUrl(e, startConsultationUrl)
    }

    handleEditClick = (e: any) => {
        RouteUtils.navigateToHrefUrl(e, RouteUtils.getPatientConsultationDetailsUrl(this.state.consultation.patient.id, this.state.consultation.id) + "/edit")
        this.props.saveConsultationData({ ...this.state.consultationData, appointmentSchedule: this.state.consultation })
    }
    // componentWillUnmount() {
    //     this.props.overridePatientNumberForAudioCall(null); // removing override
    // }

    savePrescriptionAsTemplate = () => {
        RouteUtils.navigateToHrefUrl(
            null,
            RouteUtils.getFromConsultTreatmentPlanUrl(
                this.getConsultationId(this.props).toString(),
                this.props.routeParams.patientId.toString()
            )
        );
    }

    render() {
        let allDataLoaded = this.state.consultationDetailsLoaded === LOADING_STATE.LOADED;
        const status = this.state.consultation !== null ? this.state.consultation.status : "";
        const isStartActionAllowed = AppUtils.isStartActionAllowedForConsultation(this.state.consultation);
        const consultationURL = ConsultationUtils.getStartConsultationUrl(this.state.consultation, isStartActionAllowed);
        const isConsDoctorSameAsLoggedInDoctor = this.state.consultation && this.props.doctorProfile ? this.state.consultation.doctor.id === this.props.doctorProfile.id : false;
        const isEditEnabled = !_.isEmpty(this.state.consultation) && !_.isEmpty(this.state.consultation.appointmentActionsWithContext) && !_.isEmpty(this.state.consultation.appointmentActionsWithContext.prescriptionEditActionWithContext) ?
            this.state.consultation.appointmentActionsWithContext.prescriptionEditActionWithContext.context.editEnabled : false;
        const isActionEnabled = (!_.isEmpty(this.state.consultation) && !_.isEmpty(this.state.consultation.appointmentActionsWithContext) && !_.isEmpty(this.state.consultation.appointmentActionsWithContext.prescriptionEditActionWithContext) ?
            this.state.consultation.appointmentActionsWithContext.prescriptionEditActionWithContext.context.printEnabled : false);
        const isPermitted = isActionEnabled && isConsDoctorSameAsLoggedInDoctor
        const buttonClass = isPermitted ? "" : "disabled"
        const previewButtonClass = isActionEnabled ? "" : "disabled"
        const isTreatmentPlanEnabled = !_.isEmpty(this.state.consultation)
            && !_.isEmpty(this.state.consultation.consultationProduct)
            && AppUtils.isDefined(this.state.consultation.consultationProduct.hasPrescription)
            && this.state.consultation.consultationProduct.hasPrescription
            && this.props.isTreatmentPlanEnabled
            && status === ConsultationStatusConstant.COMPLETED
        const ctaCustomStyle = { width: "88px", display: "inline" }
        const isMindConsult = AppUtils.isMindConsultation(this.state.consultation)
        return (
            <div>
                {
                    !_.isNull(this.state.errorMessage) &&
                    <ErrorContainer errorText={this.state.errorMessage} closeError={this.clearErrorMessage}
                        keepPadding={true} />
                }
                {
                    !_.isNull(this.state.confirmationText) &&
                    <ConfirmModalContainer errorText={this.state.confirmationText} okCallBack={(e: any) => this.handleOkCallBack(e, consultationURL)}
                        cancelCallBack={this.clearConfirmMessage} />
                }
                {
                    allDataLoaded &&
                    <div className="consultation-container">
                        <div className="consultation-details">
                            <div>
                                <LinkContainer
                                    to={RouteUtils.getAllConsultationsUrl(this.state.consultation.patient.id)}>
                                    <NavItem title="Completed">
                                        <div className="go-back-route-div">
                                            <span className="glyphicon glyphicon-chevron-left"
                                                aria-hidden="true"></span>
                                            All Consultations
                                        </div>
                                    </NavItem>
                                </LinkContainer>
                            </div>
                            <ConsultationDetailsHeader
                                consultation={this.state.consultation}
                                isTreatmentPlanEnabled={isTreatmentPlanEnabled}
                                redirectToTreatmentPlan={this.savePrescriptionAsTemplate}
                            />
                            {
                                status !== ConsultationStatusConstant.COMPLETED &&
                                <div>
                                    {AppUtils.isDefined(this.state.patientPersonalProfile) && <div className={"patient-medication-history-container summary-container"}>
                                        <PatientMedicationHistoryContainer doctor={this.state.consultation.doctor}
                                                                           consultationData={this.state.consultationData}
                                                                           patientPersonalProfile={this.state.patientPersonalProfile} />
                                    </div>}
                                    {/*{*/}
                                    {/*startConsultationUrl !== null ?*/}
                                    {/*<input className={"consultation-start-btn enabled"} type="button" value="Start Consultation" disabled={false} onClick={this.showConfirmBox}/>*/}
                                    {/*:*/}
                                    {/*<input className={"consultation-start-btn disabled"} type="button" value="Start Consultation" disabled={true}/>*/}
                                    {/*}*/}

                                    {/*<CurrentDateTimeContainer>*/}
                                    {/*{(currentTime: number) => {*/}
                                    {/*const consultationURL = ConsultationUtils.getStartConsultationUrl(this.state.consultation, currentTime);*/}
                                    {/*// console.log("currentTime", new Date(currentTime), consultationURL);*/}
                                    {/*}}*/}
                                    {/*return (*/}
                                    {/*</CurrentDateTimeContainer>*/}
                                    {/*);*/}
                                    <input
                                        className={`consultation-start-btn ${consultationURL && isConsDoctorSameAsLoggedInDoctor ? "enabled" : "disabled"}`}
                                        type="button"
                                        value="Start Consultation"
                                        disabled={!(consultationURL && isConsDoctorSameAsLoggedInDoctor)}
                                        onClick={(e) => this.showConfirmBox(e, consultationURL)} />
                                </div>
                            }
                            {
                                !isStartActionAllowed && status === ConsultationStatusConstant.COMPLETED &&
                                <div>
                                    <div className={"summary-container"}>
                                        <PatientConsultationSummary
                                            editClickHandler={this.handleEditClick}
                                            editEnabled={isConsDoctorSameAsLoggedInDoctor && isEditEnabled}
                                            staticMedicineTypes={this.props.medicineTypes}
                                            staticSystemicExams={this.props.staticSystemicExams}
                                            caseSummary={this.state.caseSummary}
                                            consultation={this.state.consultation}
                                            prescription={this.state.consultationData} />
                                        {/*{
                                            isLifestyleConsultation &&
                                            <Document
                                                file={{url: AlbusUrlConfigs.createDownloadPrescriptionUrl(this.state.consultation.id, AppConstants.planPdfAttachmentType.PRINT_ATTACHMENT)}}>
                                                <Page pageNumber={1} />
                                            </Document>
                                        }*/}
                                    </div>
                                    {isMindConsult && <div className={"summary-container"}>
                                        <TherapyConsultationDetailView data={this.state.consultationData}/>
                                    </div>}
                                    {!isMindConsult && <div className="button-container collapsible-card">
                                        <CTA onClick={this.previewPrescription} innerText={"Preview"} theme={CTATheme.PRIMARY} customStyle={ctaCustomStyle} disabled={!isActionEnabled} />
                                        <CTA onClick={this.printPrescription} innerText={"Print"} theme={CTATheme.PRIMARY} customStyle={ctaCustomStyle} disabled={!isPermitted} />
                                        <CTA onClick={this.emailPrescription} innerText={"Email"} theme={CTATheme.PRIMARY} customStyle={ctaCustomStyle} disabled={!isPermitted} />
                                    </div>}
                                </div>
                            }
                        </div>
                    </div>
                }
                {
                    !allDataLoaded &&
                    <AppLoader />
                }
            </div>
        )
    }
}

const mapStateToProps = (state: IAppState) => {
    return {
        staticSystemicExams: state.allStaticDataNew.systemicExaminations,
        medicineTypes: state.allStaticDataNew.medicalTypeList,
        doctorProfile: state.doctorProfile,
        chatAccessToken: state.chatAndVideoAccessTokens.chatAccessToken,
        isTreatmentPlanEnabled: state.featureConfigInfo["OrionEnablePrescriptionTemplate"]
            ? state.featureConfigInfo["OrionEnablePrescriptionTemplate"] === FeatureConfigValues.TRUE
            : true,
        appTenant: state.accountData.appTenant
    }
}

const mapDispatchToProps = (dispatch: React.Dispatch<any>): any => {
    return {
        updateCurrentChannelWithPatient: (channelSid: string, patient: IPatientDetail, identity: string) => {
            return dispatch(TwilioActions.updateCurrentChannelWithPatient(channelSid, patient, identity));
        },
        fetchAllStaticData: () => {
            return AllStaticDataActions.fetchAllStaticData(dispatch);
        },
        fetchChatContext: (appointmentId: number, commUserId: number) => {
            OngoingConsultationActions.fetchChatContext(dispatch, appointmentId, commUserId);
        },
        downloadPrescription: (appointmentId: number, type: string) => {
            PrescriptionAction.downloadPrescription(appointmentId, type);
        },
        printPrescription: (appointmentId: number, type: string) => {
            PrescriptionAction.printPrescription(appointmentId, type);
        },
        sendPrescription: (bookingId: number, appointmentId: number) => {
            return PrescriptionAction.sendPrescription(bookingId, appointmentId);
        },
        sendPlan: (appointmentId: number, curefitUserId: string, bookingId: number) => {
            return PrescriptionAction.sendPlan(appointmentId, curefitUserId, bookingId);
        },
        saveConsultationData: (consultationData: IOngoingConsultation) => {
            dispatch(EditPrescriptionActions.fetchEditPrescriptionDetailsSuccess(consultationData));
        },
        overridePatientNumberForAudioCall: (phoneNumber: number) => dispatch(OverrideActions.overridePatientNumberForAudioCall(phoneNumber)),
        
        closeWhatsAppChatContext: () => {
            return dispatch(WhatsAppChatActions.closeWhatsAppChat());
        },
        updateWhatsAppChatContext: (patientInfo: WhatsAppPatientInfo) => {
            return dispatch(WhatsAppChatActions.updateWhatsAppPatientInfo(patientInfo));
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PatientConsultationDetailContainer);
